
export default {
  namespaced: true,
  state: {
    data: {
      type: 'default',
      form: null
    }
  },
  mutations: {
    setReminder (state, reminder) {
      state.data = reminder
      if (reminder) {
        localStorage.setItem('reminder', JSON.stringify(reminder))
      } else {
        localStorage.removeItem('reminder')
      }
    }
  }
}